import { render, staticRenderFns } from "./SupplyTgLeftDetail.vue?vue&type=template&id=3c3fddd3&scoped=true"
import script from "./SupplyTgLeftDetail.vue?vue&type=script&lang=js"
export * from "./SupplyTgLeftDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplyTgLeftDetail.vue?vue&type=style&index=0&id=3c3fddd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fddd3",
  null
  
)

export default component.exports